/**
 * Преобразуем дату из строки в формате ISO в экземпляр `Date` без приведения к часовому поясу пользователя
 * @param isoDate Дата в формате ISO, например `2023-04-11T00:00:00Z`
 */
export default function dateToUTC(isoDate: string) {
  const date = new Date(isoDate);

  const userTimezoneOffset = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() + userTimezoneOffset);
}
